<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><span class="t4">Per tutti coloro che mi hanno accompagnata</span></p>
<p class="p6"><span class="t4">nel viaggio di Jin e Logan: grazie.</span></p>
<p class="p6"><span class="t4">È stato un privilegio.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?0e403751